/* globals */

import httpClient from './lib/httpClient'

export const updateCompany = async (payload) => {
  const endpoint = '/api/Company/update'
  return httpClient.post(endpoint, payload)
}

export const getCountToday = async (payload) => {
  const endpoint = '/api/Appointment/count/?companyId=' + payload.companyId + '&date=' + payload.date
  return httpClient.get(endpoint)
}

export const getPriceSumForMonth = async (payload) => {
  const endpoint = '/api/Company/priceSumForMonth/?companyId=' + payload.companyId + '&date=' + payload.date
  return httpClient.get(endpoint)
}

export const getPriceSumForDay = async (payload) => {
  const endpoint = '/api/Company/priceSumForDay/?companyId=' + payload.companyId + '&date=' + payload.date
  return httpClient.get(endpoint)
}

export const uploadLogo = async (payload) => {
  const endpoint = '/api/Company/upload/?companyId=' + payload.companyId
  return httpClient.post(endpoint, payload.file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
}

export const upload = async (payload) => {
  const endpoint = '/api/Appointment/upload/?appointmentId=' + payload.appointmentId
  return httpClient.post(endpoint, payload.file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
}

export default {
  updateCompany,
  getCountToday,
  upload,
  uploadLogo,
  getPriceSumForMonth,
  getPriceSumForDay
}
